<template>
  <div>
    <el-transfer filterable :filter-method="filterMethod" filter-placeholder="Campos" v-model="value"
      :titles="['Disponiveis', 'Selecionados']" :data="tableData" target-order="push">
      <el-button type="info" class="transfer-footer" slot="right-footer" size="small" @click="save()">Salvar esse
        layout</el-button>
    </el-transfer>
  </div>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { LayoutService } from "@/services/customers/layout.services";
export default {
  props: ['tableData', 'layout', 'type', 'fields'],
  methods: {
    apply(fields) {
      this.value = fields;
    },
    get() {
      return this.value;
    },
    save() {
      const vm = this;
      if (vm.value.length == 0) {
        this.$message({
          type: "error",
          message: "Selecione ao menos um campo para salvar o layout",
        });
        return false;
      }

      if (vm.layout) {
        this.$confirm(
          `Você deseja sobrepor o layout que está selecionado?`,
          i18n.tc("aviso"),
          {
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            type: i18n.tc("aviso"),
            center: true,
          }
        ).then(() => {
          const loading = vm.$loading(vm.$options.loading);
          const f = vm.value.map(x => x);
          LayoutService.update(vm.layout, {
            fields: f,
            type: vm.type,
          }).then((response) => {
            vm.$emit('save', response);
            this.$message({
              type: "success",
              message: "Layout alterado com sucesso!",
            });
          })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        }).catch(() => {
          vm.newLayout();
        });
      } else {
        vm.newLayout();
      }
    },
    newLayout() {
      const vm = this;
      this.$prompt("Informe um nome para o layout", "Salvar", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputPlaceholder: "Informe um nome",
        inputErrorMessage: "É obrigatório informar um nome",
        inputValidator: function (v) {
          if (!v) {
            return false;
          }
        },
      })
        .then(async ({ value }) => {
          const loading = vm.$loading(vm.$options.loading);
          const data = {
            name: value,
            fields: vm.value.map(x => x),
            type: vm.type,
          };
          LayoutService.add(data)
            .then(response => {
              vm.$emit('save', response);
              this.$message({
                type: "success",
                message: "Layout salvo com sucesso",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        })
        .catch(() => { });
    },
  },
  data() {
    return {
      filterMethod(query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      value: [],
    }
  },
}
</script>
